import { useI18n } from '@change-corgi/core-react/i18n';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

import { usePromoteFormData } from '../../../../../../../../formContext';

type ButtonAmount = {
	value: string;
	valueDisplay: string;
	suggestedLabel?: string;
};

export function useButtonAmounts(): ButtonAmount[] {
	const {
		amountChoices,
		currency: { code: currencyCode },
	} = usePromoteFormData();

	const {
		data: { promoteShareOnComboExperiment },
	} = usePsfPromoteOrSharePageData();

	const { localizeCurrency } = useI18n();

	return amountChoices.map((choice, index) => ({
		value: `${choice.amount}`,
		valueDisplay: localizeCurrency(choice.amount, currencyCode),
		suggestedLabel: index === 2 && promoteShareOnComboExperiment.variation === 'variant_1' ? 'Suggested' : undefined,
	}));
}
